export default __webpack_public_path__ + "static/media/frshMindLogo.9798fb4c.svg";